/** Marker on `<a>` tags inserted only via MixItOne UI; resolved server-side to a first-party directory URL. */
export const FUNDING_APPEAL_LANDING_CTA_ATTR = "data-mixitone-funding-cta";

/** Only value accepted through the email builder sanitizer for {@link FUNDING_APPEAL_LANDING_CTA_ATTR}. */
export const FUNDING_APPEAL_LANDING_CTA_VALUE = "appeal_landing";

const DEFAULT_CTA_LABEL = "View appeal page";

function escapeHtmlText(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}

/**
 * HTML snippet for an appeal landing CTA. The `href` is a placeholder; the send path replaces it with a
 * constructed directory URL and strips {@link FUNDING_APPEAL_LANDING_CTA_ATTR}.
 */
export function fundingAppealLandingCtaAnchorHtml(options?: { label?: string }): string {
  const raw = (options?.label ?? DEFAULT_CTA_LABEL).trim() || DEFAULT_CTA_LABEL;
  const label = escapeHtmlText(raw);
  return `<p><a ${FUNDING_APPEAL_LANDING_CTA_ATTR}="${FUNDING_APPEAL_LANDING_CTA_VALUE}" href="#" style="display:inline-block;padding:12px 20px;background-color:#2563eb;color:#ffffff;text-decoration:none;border-radius:6px;font-weight:600;">${label}</a></p>`;
}
